function initMap() {
    const location = {lat: 53.555225393767685, lng: -1.47920428652745};

    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 17,
        center: location,
    });

    const marker = new google.maps.Marker({
        position: location,
        map: map,
    });
}

window.initMap = initMap;

export default initMap;
